import React, { useState } from 'react';
import { useMemoizedFn } from 'ahooks';
import { Form, Input, Modal } from '@bedrock/components';
import type { DeviceRecord } from './types';

const MODAL_WIDTH = 480;
const REMARK_MAX_LENGTH = 100;
const MAC_ADDRESS_PATTERN = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;

interface DeviceModalProps {
  visible: boolean;
  /** 编辑模式时传入当前行数据，添加模式传 null */
  editingRecord: DeviceRecord | null;
  onCancel: () => void;
  onOk: (values: { mac_address: string; remark?: string }) => Promise<void>;
}

const DeviceModal: React.FC<DeviceModalProps> = (props) => {
  const { visible, editingRecord, onCancel, onOk } = props;
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const isEdit = !!editingRecord;

  const handleOk = useMemoizedFn(async () => {
    let values: { mac_address: string; remark?: string };
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    try {
      setConfirmLoading(true);
      await onOk(values);
      onCancel();
    } catch (error) {
      console.error(error);
    } finally {
      setConfirmLoading(false);
    }
  });

  const handleAfterOpen = useMemoizedFn(() => {
    if (editingRecord) {
      form.setFieldsValue({
        macAddress: editingRecord.macAddress,
        remark: editingRecord.remark,
      });
    }
  });

  const handleAfterClose = useMemoizedFn(() => {
    form.resetFields();
  });

  return (
    <Modal
      title={isEdit ? '编辑设备' : '添加设备'}
      visible={visible}
      width={MODAL_WIDTH}
      maskClosable={false}
      onOk={handleOk}
      onCancel={onCancel}
      afterOpen={handleAfterOpen}
      afterClose={handleAfterClose}
      okButtonProps={{ loading: confirmLoading }}
      cancelButtonProps={{ disabled: confirmLoading }}
      closable={!confirmLoading}
    >
      <Form form={form} layout="vertical" showLabelColon className="w-full">
        <Form.Item
          label="Mac地址"
          name="macAddress"
          rules={[
            { required: true, message: '请输入Mac地址' },
            { pattern: MAC_ADDRESS_PATTERN, message: '请输入正确的Mac地址，格式如 AA:BB:CC:DD:EE:FF' },
          ]}
        >
          <Input placeholder="请输入" disabled={isEdit} className="w-full" />
        </Form.Item>
        <Form.Item label="备注" name="remark">
          <Input.TextArea
            placeholder="请输入"
            maxLength={REMARK_MAX_LENGTH}
            showCount
            className="w-full"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DeviceModal;